import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  postLecturerList: (params: LecturerListReqDto): Promise<LecturerListResDto> =>
    request({
      url: endpoints.lecturer.list,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postLecturerInfo: (params: CommonIdReqDto): Promise<LecturerInfoResDto> =>
    request({
      url: endpoints.lecturer.info,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postLecturerAdd: (params: LecturerSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.lecturer.add,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postLecturerUpdate: (params: LecturerSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.lecturer.update,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postLecturerActivate: (params: LecturerSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.lecturer.activate,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postLecturerFileUpdate: (params: LecturerSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.lecturer.filesave,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postLecturerDelete: (params: LecturerSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.lecturer.delete,
      method: 'post',
      data: paramsToFormData(params),
    }),
  getLecturerCodeList: (): Promise<UserCodeListResDto> =>
    request({
      url: endpoints.lecturer.codelist,
      method: 'get',
    }),   
  postLecturerGtokenSave: (params: LecturerGTokenSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.lecturer.gtokensave,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postLecturerHistoryList: (params: LecturerHistoryListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.lecturer.history,
      method: 'post',
      data: paramsToFormData(params),
    }),   
};
